import { render, staticRenderFns } from "./recommendedcourses.vue?vue&type=template&id=3c2f799e&scoped=true&"
import script from "./recommendedcourses.vue?vue&type=script&lang=js&"
export * from "./recommendedcourses.vue?vue&type=script&lang=js&"
import style0 from "./recommendedcourses.vue?vue&type=style&index=0&id=3c2f799e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c2f799e",
  null
  
)

export default component.exports